import { createContext, useContext, useEffect, useState } from 'react';
import { translations, LANGUAGES } from './translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('dd-lang') || 'ro');

  useEffect(() => {
    localStorage.setItem('dd-lang', lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (path) => {
    const resolve = (obj) => path.split('.').reduce((o, k) => (o == null ? undefined : o[k]), obj);
    return resolve(translations[lang]) ?? resolve(translations.ro) ?? path;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
